export const PERMISSION = [
    {
        'home': {
            'buy_only': 'home',
            'manage_only': 'manage',
            'buy_and_manage': 'home'
        },
        
    }
];
